// extracted by mini-css-extract-plugin
module.exports = {"cardContainer":"Card_cardContainer__2U1y0","hover":"Card_hover__3Nl5i","header":"Card_header__2mhaM","content":"Card_content__3WDUc","opacity":"Card_opacity__1jzF7"};